
import { redireccionar } from "../utilidades/funciones.tsx"
import "./tarjeta.css"


interface tarjetaParams{
    titulo: string
    icono: string
    url: string
    size?: string | number
    disabled?: boolean
}

export const Tarjeta = ({titulo,icono,url,size="4rem",disabled=false}:tarjetaParams)=>{
    
    return(
        <div className="d-flex justify-content-center align-items-center">
            <button type="button"
                    className="tarjeta"
                    onClick={()=>redireccionar(url)}
                    disabled={disabled}
            >        
                <h6>{titulo}</h6>
                <i 
                    className={icono}
                    style={{fontSize:size}}
                ></i>
            </button>
        </div>
    )
}